import { resolveComponentVariant } from '../componentContract'
import styles from './Primitives.module.css'

const tones = ['neutral', 'info', 'success', 'warning', 'danger']

export function Badge({ tone = 'neutral', compact = false, children, className = '', title }) {
  const resolvedTone = resolveComponentVariant('Badge tone', tone, tones, 'neutral')
  return (
    <span title={title} className={[
      styles.badge,
      resolvedTone !== 'neutral' ? styles[`badge${resolvedTone[0].toUpperCase()}${resolvedTone.slice(1)}`] : '',
      compact ? styles.badgeCompact : '',
      className,
    ].filter(Boolean).join(' ')}>
      {children}
    </span>
  )
}
